import { render, staticRenderFns } from "./EditorCenter.vue?vue&type=template&id=5329b364&scoped=true&"
import script from "./EditorCenter.vue?vue&type=script&lang=js&"
export * from "./EditorCenter.vue?vue&type=script&lang=js&"
import style0 from "./EditorCenter.vue?vue&type=style&index=0&id=5329b364&prod&lang=css&scoped=true&"
import style1 from "./EditorCenter.vue?vue&type=style&index=1&id=5329b364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5329b364",
  null
  
)

export default component.exports